import { render, staticRenderFns } from "./userProjects.vue?vue&type=template&id=74720b6c&scoped=true&"
import script from "./userProjects.vue?vue&type=script&lang=js&"
export * from "./userProjects.vue?vue&type=script&lang=js&"
import style0 from "./userProjects.vue?vue&type=style&index=0&id=74720b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74720b6c",
  null
  
)

export default component.exports